<template>
  <div class=" h-100-vh">
    <div class=" " :class=" integration ? 'card card-ecart' : '' ">
      <div class=" " :class=" integration ? 'card-header' : '' ">
        <div class="row justify-content-between align-items-center ">
          <div class="col col-sm-auto" v-show="integration">
            <h5 v-text="  $t('dashboard.account.title')  "> </h5>
          </div>
          <!-- <div class="col-auto ml-auto">
            <Languages size="sm" />
          </div> -->
        </div>
      </div>
      <!-- <div class="d-md-none" :class=" integration ? 'card-body' : '' ">
        <div class="row justify-content-between">
          <div class="col-12">
            <p class=" text-truncate mb-0 ">
              <strong v-text=" $t('general.form.email') + ': ' "></strong>
              <span
                v-text=" userSession.email ">
              </span>
            </p>
             <p class=" text-truncate mb-0 ">
              <strong v-text=" 'Seller ID: ' "></strong>
              <strong class="text-success" v-text=" userSession.seller_id "> </strong>
            </p>
          </div>
          <div class="col-12">
           
          </div>
        </div>
      </div> -->
      <div class="" :class=" integration ? 'card-footer' : '' ">
        <v-observer class="form-rounded-inputs" ref="formSellerInfo" tag="form" @submit.prevent="fnApiUpdateUserInfo()">

          <div class="row align-items-end ">

            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="col-form-label" v-text=" $t('dashboard.account.name') "></label>
                <v-validation rules="required|min:3" v-slot="{ errors }" :name=" $t('dashboard.account.name') ">
                  <input v-model="user.first_name " placeholder="Robert" class="form-control" type="text"
                    :class=" { 'is-invalid':errors.length > 0 } ">
                  <div class="invalid-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </div>
                </v-validation>
              </div>
            </div>

            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="col-form-label" v-text=" $t('dashboard.account.lastName') "></label>
                <v-validation rules="required|min:3" v-slot="{ errors }" :name=" $t('dashboard.account.lastName') ">
                  <input v-model="user.last_name " placeholder="Martin" class="form-control" type="text"
                    :class=" { 'is-invalid':errors.length > 0 } ">
                  <div class="invalid-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </div>
                </v-validation>
              </div>
            </div>
            <div class="col-12"></div>

            <div class="col-12 col-md-4">

              <div class="form-group">
                <label class="col-form-label" v-text=" $t('dashboard.account.phone') "></label>
                <v-validation rules="required|min:10" v-slot="{ errors }" :name=" $t('dashboard.account.phone') ">
                  <div class="input-group ">
                    <the-mask v-model="user.phone " class="form-control" type="text" placeholder="81-8080-8080"
                      mask="##-####-####" :class=" { 'is-invalid':errors.length > 0 } " />
                    <div class="input-group-append">
                      <span class="input-group-text rounded-right"> <strong>
                          <i class=" fa fa-phone "></i> </strong>
                      </span>
                    </div>
                    <div class="invalid-feedback" v-if="errors.length > 0">
                      {{ errors[0] }}
                    </div>
                  </div>
                </v-validation>
              </div>

            </div>

            <div class="col-12 col-md-4">

              <v-validation rules="required" v-slot="{ errors }" :name=" $t('dashboard.account.country') ">
                <div class="form-group">
                  <label for="" v-text="$t('dashboard.account.country')"></label>
                  <div class="input-group " :class=" { 'is-invalid ':errors.length > 0 } ">
                    <select class="custom-select" v-model="user.country" :class=" { 'is-invalid':errors.length > 0 } ">
                      <option :value="null" selected v-text=" $t('general.form.select') "> </option>
                      <option :value="country.code" v-for="  country in countriesList  " :key="country.code"
                        v-text="country.name">
                      </option>
                    </select>
                    <div class="input-group-append">
                      <label class="input-group-text"> <i class="fa fa-flag"></i> </label>
                    </div>
                  </div>

                  <div class="invalid-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </div>
                </div>
              </v-validation>
            </div>
            <div class="col-12 col-md-4">

              <v-validation rules="required" v-slot="{ errors }" :name=" $t('general.language') ">
                <div class="form-group">
                  <label for="" v-text="$t('general.language')"></label>
                  <div class="input-group " :class=" { 'is-invalid ':errors.length > 0 } ">
                    <select class="custom-select " :class=" { 'is-invalid ':errors.length > 0 } "
                      v-model="user.language" @change="setLanguage($event.target.value)">
                      <option :value="null" selected v-text=" $t('general.form.select') "> </option>
                      <option value="es">Español</option>
                      <option value="en">English</option>
                    </select>
                    <div class="input-group-append">
                      <label class="input-group-text">
                        <i class="fa fa-language"></i>
                      </label>
                    </div>
                  </div>

                  <div class="invalid-feedback" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </div>
                </div>
              </v-validation>
            </div>


            <div class="col-12 col-md-auto ml-auto">
              <button class=" btn btn-success w-100" :disabled="sendingData">
                <span v-text=" integration ? $t('general.button.next') : $t('general.button.update') "
                  v-if=" !sendingData "></span>
                <i class="fa fa-spinner fa-spin " v-else></i>
              </button>
            </div>

          </div>
          <input type="submit" hidden>
        </v-observer>
      </div>
    </div>
  </div>
</template>


<script>
  import Languages from "@/components/Languages"
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex';
  export default {
    components: {
      Languages,
    },
    data() {
      return ({
        sendingData: false,
        user: {
          first_name: null,
          last_name: null,
          phone: null,
          country: null,
          language: null,
        },
        countriesList: [],
      })
    },
    computed: {
      ...mapState(['integration']),
      ...mapState({
        userSession: state => state.session.user,
        language: state => state.menu.language,
      }),
    },
    methods: {
      ...mapMutations('session', ['setSession']),
      ...mapMutations(['setIntegration','setLanguage']),

      async fnApiUpdateUserInfo() {
        this.sendingData = true;
        if (await this.$refs['formSellerInfo'].validate()) {
          let {
            first_name,
            last_name,
            country,
            phone,
            language
          } = this.user;
          await axios.put('me', {
            first_name,
            last_name,
            country,
            phone,
            language
          }).then(response => {
            this.setSession(response.data);

            localStorage.setItem('user', JSON.stringify(response.data));
            this.$toasted.global.infoMessage(this.$t('toasted.info.accountUpdated'));

            if (this.integration) {
              setTimeout(() => {
                this.$router.push('/dashboard/stores?integration=true');
              }, 800);
            }
          }).catch(error => {});
        }
        this.sendingData = false;
      },

      fnApiGetUserInfo() {
        axios.get('me').then(response => {
          if( response.data.language == null || response.data.language == undefined ){
            // response.data.language =  this.language;
          }
          this.user = { ...response.data };
          this.setLanguage(this.user.language);
        }).catch(error => {});
      },

    },
    async mounted() {
      this.fnApiGetUserInfo();
      this.countriesList = await this.fnApiGetCountries();

      if (this.$route.query.integration) {
        this.setIntegration(true);
        this.$store.commit('menu/setStepNumber', 1);
      }

    }
  }
</script>